"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsHeaderInner = exports.TabsHeader = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _useStyles = require("../../helpers/useStyles");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _usePropsUpdatedChildren = require("../../helpers/usePropsUpdatedChildren");

var _tab = require("./tab");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(".c1d376926{display:flex}.c308921a9{flex-wrap:wrap}.c4119061b{flex-wrap:wrap}.c89b5015c{box-shadow:0 .0625rem 0 var(--color-gray-20);margin-bottom:.0625rem}");
var styles = {
  root: 'c1d376926',
  '--view-usual': 'c308921a9',
  '--view-child': 'c4119061b',
  '--view-secondary': 'c89b5015c'
};
/* prevent props errors on init */

var TabsHeader = function TabsHeader(props) {
  return /*#__PURE__*/_react.default.createElement(TabsHeaderInner, props);
};

exports.TabsHeader = TabsHeader;

var TabsHeaderInner = function TabsHeaderInner(props) {
  var children = props.children,
      classes = props.classes,
      view = props.view;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var elementTypes = [_tab.Tab];

  var updateFunc = function updateFunc(oldProps) {
    return !oldProps ? {
      view: view
    } : _objectSpread(_objectSpread({}, oldProps), {}, {
      view: view
    });
  };

  var updatedChildren = (0, _usePropsUpdatedChildren.usePropsUpdatedChildren)(children, elementTypes, updateFunc);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, updatedChildren);
};

exports.TabsHeaderInner = TabsHeaderInner;
TabsHeaderInner.propTypes = {
  children: _propTypes.node.isRequired,
  classes: (0, _getClassesPropType.getClassesPropType)(styles),
  view: _propTypes.string.isRequired
};
TabsHeaderInner.defaultProps = {
  classes: {}
};